<template>
  <div class="row cards-row" v-if="totalProfit">
    <div class="col-lg-4">
      <div class="auth-card return">
        <div class="auth-card-header">
          <div class="auth-card-header-icon">₮</div>
          <p>Нийт хөрөнгө оруулалт</p>
        </div>
        <div class="amount">
          <p class="currency">
            <masked-amount>
              <template #visible>
                ₮{{ totalProfit.total | currency('', '') }}
                <span class="suffix"> MNT </span>
              </template>
              <template #hidden>
                ₮****** <span class="suffix"> MNT </span>
              </template>
            </masked-amount>
          </p>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="auth-card return">
        <div class="auth-card-header">
          <div class="auth-card-header-icon">₮</div>
          <p>Одоогийн үнэлгээ</p>
        </div>
        <div class="amount">
          <p class="currency">
            <masked-amount>
              <template #visible>
                ₮{{ totalProfit.current | currency('', '') }}
                <span class="suffix"> MNT </span>
              </template>
              <template #hidden>
                ₮****** <span class="suffix"> MNT </span>
              </template>
            </masked-amount>
          </p>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="auth-card return">
        <div class="auth-card-header">
          <div class="auth-card-header-icon">₮</div>
          <p>Ашиг/Алдагдал</p>
        </div>
        <div class="amount">
          <p
            class="currency"
            :class="{
              red: lost,
              green: profited,
            }"
          >
            <masked-amount>
              <template #visible>
                <template v-if="profited"> + </template>
                <template v-else></template>
                {{ profit | currency('', '') }}
                <span class="suffix"> MNT </span>
              </template>
              <template #hidden>
                ****** <span class="suffix"> MNT </span>
              </template>
            </masked-amount>
          </p>
        </div>
        <div class="small-amount">
          <p class="label">Ашиг/Алдагдал</p>
          <p
            class="amount"
            :class="{
              red: lost,
              green: profited,
            }"
          >
            <masked-amount placeholder="******%">
              <template #visible>
                <template v-if="profited"> + </template>
                <template v-else></template>
                {{
                  ((profit / totalProfit.total) * 100)
                    | currency('', '')
                }}%
              </template>
            </masked-amount>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MaskedAmount from '../global/MaskedAmount'

export default {
  components: {
    MaskedAmount,
  },
  computed: {
    ...mapGetters({
      totalProfit: 'totalProfit'
    }),
    profit() {
      return this.totalProfit.diff
    },
    profited() {
      return (
        this.totalProfit.diff >= 0
      )
    },
    lost() {
      return (
        this.totalProfit.diff < 0
      )
    },
  },
}
</script>

<style lang="scss"></style>
